module.exports = __webpack_public_path__ + "img/thumbnail_FireSalamander_u_albino.2175fe8f.png";